import query from './APIServices'

export interface costCategory {
  id: number
  name: string
  description: string
}

export const getCostCategories = async () => {
  const response = await query.get('/administration/fixedcostcategory')
  return response?.data.items as costCategory[]
}
